import { render, staticRenderFns } from "./AddCIBPaymentDialog.vue?vue&type=template&id=2ed1d2de&scoped=true"
import script from "./AddCIBPaymentDialog.vue?vue&type=script&lang=js"
export * from "./AddCIBPaymentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed1d2de",
  null
  
)

export default component.exports